var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.myClass,attrs:{"id":"page-content"}},[(_vm.message)?_c('InfoBox',{attrs:{"message":_vm.message}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }